import { cn } from "@/lib/utils"

/**
 * A loading placeholder.
 *
 * `bg-foreground/10` rather than `bg-accent`, which is what shadcn ships and
 * what this was. Stock shadcn assumes `--accent` is a near-neutral hover tint,
 * so a skeleton drawn with it reads as a pale grey block. This app redefines
 * `--accent` as a saturated violet — `#ede9fe` light, `#3730a3` dark — because
 * it marks the SELECTED or HOVERED thing, which is a good reason for a strong
 * colour and a bad one for an inert placeholder.
 *
 * In light mode `#ede9fe` is pale enough that nobody noticed. In dark mode
 * `#3730a3` is a solid indigo slab: the Rebalancer's `h-64 w-full` skeleton
 * filled the page with a bright rectangle, which is how this was found. The
 * bug was latent the whole time and only became visible once dark mode
 * actually applied to those pages.
 *
 * Tracking `--foreground` at 10% keeps it neutral in both themes — a wash a
 * step off the surface, in the colour the text would have been — and cannot be
 * broken again by a palette change to `--accent`. Callers may still override
 * via `className`; none currently do.
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-foreground/10", className)}
      {...props}
    />
  )
}

export { Skeleton }
